export const tooltipVariants = {
  animate: (isDesktop: boolean) => ({
    y: isDesktop ? '-80%' : '-20%',
    x: isDesktop ? '-60%' : '0%',
    opacity: 1,
    transition: {
      y: {
        type: 'spring',
        stiffness: 170,
      },
    },
  }),
  exit: (isDesktop: boolean) => ({
    y: isDesktop ? '-60%' : '0%',
    x: isDesktop ? '-60%' : '0%',
    opacity: 0,
    transition: {
      y: {
        type: 'spring',
        stiffness: 170,
      },
    },
  }),
}
